import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, map } from "rxjs";
import { TaskData, TasksSearchSpecificationDTO } from "./taskData";

@Injectable({
  providedIn: "root",
})
export class TaskTrayService {
  constructor(private http: HttpClient) { }

  public dataSubject = new BehaviorSubject<any>(null);

  sendData(data: any): void {
    this.dataSubject.next(data);
  }

  getData(): any {
    return this.dataSubject.asObservable();
  }

  findRecords(sort, pageIndex = 0, pageSize, firstName, operationalStatus, applicationCreatedOn, hoUserOwned): Observable<TaskData> {
    // let params = new HttpParams()
    //   .set('page', pageIndex)
    //   .set('size', pageSize)
    //   .set('sort', sort)
    //   .set('firstName', firstName)
    //   .set('operationalStatus', operationalStatus)
    //   .set('applicationCreatedOn', applicationCreatedOn)
    //   .set('hoUserOwned', hoUserOwned);
    // return this.http.get<TaskData[]>(`/api/application/depositApplication/search`, {
    //   observe: 'response',
    //   params: params
    // }).pipe(
    //   map(response => {
    //     return { data: response.body, totalCount: +response.headers.get("X-Total-Count") }
    //   })
    // );
    return null;
  }

  getById(id: string): Observable<TaskData> {
    return this.http.get<TaskData>(`/api/application/depositApplication/${id}`).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getTaskDataForGroupTray(params: TasksSearchSpecificationDTO): Observable<TaskData[]> {
    const filteredParams = Object.keys(params).filter(key => params[key] != null && key !== 'assignee')
      .reduce((obj, key) => {
        obj[key] = params[key];
        return obj;
      }, {});
    return this.http.get<TaskData[]>(`api/workflow/tasksByGroup`, { params: filteredParams }).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getTaskDataForSelfTray(params: TasksSearchSpecificationDTO): Observable<TaskData[]> {
    const filteredParams = Object.keys(params).filter(key => params[key] != null && key !== 'assignee')
      .reduce((obj, key) => {
        obj[key] = params[key];
        return obj;
      }, {});
    return this.http.get<TaskData[]>(`api/workflow/tasksByAssignee`, { params: filteredParams }).pipe(
      map((response) => {
        return response;
      })
    );
  }
  completeTask(taskId: string): Observable<string> {
    return this.http.post<string>(`api/workflow/task/complete?taskId=${taskId}`, null).pipe(
      map((response) => {
        return response;
      })
    );
  }

  claimTask(taskIds: string[] | string, username?: string): Observable<any> {
    // Always convert to list
    const tasks = Array.isArray(taskIds) ? taskIds : [taskIds];

    let url = `api/workflow/claim`;
    if (username) {
      url += `?user=${username}`;
    }

    return this.http.post<any>(url, tasks);
  }
  unClaimTask(taskIds: string[]): Observable<any> {
    return this.http.post<string>(`api/workflow/un-claim`, taskIds).pipe(
      map((response) => {
        return response;
      })
    );
  }

  deleteTask(taskId: string): Observable<string> {
    return this.http.delete<string>(`api/workflow/task?taskId=${taskId}`).pipe(
      map((response) => {
        return response;
      })
    );
  }

  deleteProcess(taskId: string): Observable<string> {
    return this.http.delete<string>(`api/workflow/delete/process/task?taskId=${taskId}`).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getTaskData(taskId: string): Observable<TaskData> {
    return this.http.get<TaskData>(`api/workflow/task/${taskId}`).pipe(
      map((response) => {
        return response;
      })
    );
  }

  approveTask(remarkFormData: any): Observable<string> {
    // console.log('approveTask', remarkFormData);
    return this.http.post<string>(`api/workflow/task/approve`, remarkFormData).pipe(
      map((response) => {
        return response;
      })
    );
  }

  rejectTask(remarkFormData: any): Observable<string> {
    return this.http.post<string>(`api/workflow/task/reject`, remarkFormData).pipe(
      map((response) => {
        return response;
      })
    );
  }

  continueTask(remarkFormData: any): Observable<string> {
    return this.http.post<string>(`api/workflow/task/continue`, remarkFormData).pipe(
      map((response) => {
        return response;
      })
    );
  }

  retryTask(remarkFormData: any): Observable<string> {
    return this.http.post<string>(`api/workflow/task/retry`, remarkFormData).pipe(
      map((response) => {
        return response;
      })
    );
  }

  reworkTask(remarkFormData: any): Observable<string> {
    return this.http.post<string>(`api/workflow/task/rework`, remarkFormData).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getTaskDataForGroupTrayByCaseId(caseId: string): Observable<TaskData[]> {
    return this.http.get<TaskData[]>(`api/workflow/tasksByGroup?candidateGroup=BRANCH_USER&caseId=${caseId}`).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getTaskDataForSelfTrayByCaseId(caseId: string): Observable<TaskData[]> {
    return this.http.get<TaskData[]>(`api/workflow/tasksByAssignee?caseId=${caseId}`).pipe(
      map((response) => {
        return response;
      })
    );
  }

  startWorkflowProcess(applicationId: string): Observable<any> {
    return this.http.get<any>(`api/workflow/start-process/application/${applicationId}`);
  }

  recommendTask(remarkFormData: any): Observable<string> {
    return this.http.post<string>(`api/workflow/task/recommend`, remarkFormData).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getAllManagerTasks(params: TasksSearchSpecificationDTO): Observable<TaskData[]> {
    const filteredParams = Object.keys(params)
      .filter(key => params[key] != null && key !== 'assignee')
      .reduce((obj, key) => {
        obj[key] = params[key];
        return obj;
      }, {});

    return this.http.get<TaskData[]>(`api/workflow/allManagerTasks`, { params: filteredParams })
      .pipe(map(response => response));
  }

  getTaskByEntity(entityType: string, entityValue: string) {
  return this.http.get<TaskData>('/api/workflow/tasks/by-entity', {
    params: { entityType, entityValue }
  });
}

getWorkflowHistory(processInstanceId: string) {
  return this.http.get<any[]>(
    `api/workflow/process/workflow-history`,
    {
      params: {
        processInstanceId,
      },
    }
  );
}
}




